import { useState, useRef } from 'react'
import { SelectProps } from './Select.types'
import { config } from 'config'

export const useSelect = ({
  onClear,
  multiselect,
  handleChange,
  value,
  options = [],
  placeholder,
  error,
  renderNames = true,
  onClose,
  isOpen: passedIsOpen,
  onInputClick,
}: SelectProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const isPlaceholderVisible = !value.length

  const handleToggle = () => {
    setIsOpen(prevIsOpen => !prevIsOpen)
    if (!onInputClick || !onClose) return
    passedIsOpen ? onClose() : onInputClick()
  }

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }
    if (onClose) onClose()
    setIsOpen(false)
  }

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === config.TAB_KEY) {
      event.preventDefault()
      if (onClose) onClose()
      setIsOpen(false)
    }
  }

  const handleItemClick = (itemValue: string | number) => {
    if (!handleChange) return setIsOpen(false)
    if (multiselect) {
      return value.includes(itemValue)
        ? handleChange(value.filter(val => val !== itemValue))
        : handleChange([...value, itemValue])
    }
    handleChange([itemValue])
    if (onClose) onClose()
    setIsOpen(false)
  }

  const handleClear = () => {
    if (onClear) onClear()
    if (onClose) onClose()
    setIsOpen(false)
  }

  const getTitle = () => {
    if (typeof error === 'string' && error) return error
    if (isPlaceholderVisible) return placeholder

    const itemsToDisplay = renderNames
      ? value.map(val => options.find(opt => opt.value === val)?.title)
      : value
    return itemsToDisplay.join(', ')
  }

  return {
    anchorRef,
    handleClear,
    handleItemClick,
    handleListKeyDown,
    handleToggle,
    handleClose,
    getTitle,
    isOpen: passedIsOpen === undefined ? isOpen : passedIsOpen,
    isPlaceholderVisible,
  }
}
